import { IFundRule } from '../rules/ifund-rule'
import { FundCategoryCode } from './fund-category-code.enum'

export class LowerLvlCategoryFundRuleModel {
  private readonly _catLvl1Name: string = ''
  private readonly _catLvl2Name: string = ''
  private readonly _catLvl3Name: string = ''

  constructor(
    private _fundRule: IFundRule,
    catLvl1Name: FundCategoryCode,
    catLvl2Name?: FundCategoryCode,
    catLvl3Name?: FundCategoryCode,
  ) {
    this._catLvl1Name = catLvl1Name.toString()
    if (catLvl2Name && catLvl2Name !== catLvl1Name) {
      this._catLvl2Name = catLvl2Name.toString()
    }
    this._catLvl3Name = catLvl3Name.toString()
  }

  get fundRule(): IFundRule {
    return this._fundRule
  }

  get catLvl1Name(): string {
    return this._catLvl1Name
  }

  get catLvl2Name(): string {
    return this._catLvl2Name
  }

  get catLvl3Name(): string {
    return this._catLvl3Name
  }
}
